/*eslint no-unused-vars:0 */
var _ = require('ES/lib/lodash');
var Balboa = require('ES/services/Balboa');
var RadioService = require("ES/lib/react-pubsub-via-radio.js/service");


module.exports.init = function() {

    RadioService('Quickbooks_readAuth', function(data, callback) {
        Balboa.api('/quickbooks/readauth', {
            sid: data.sid
        }, function(data) {
            callback(null, data);
        }, function(data) {
            callback((data && data.message) || ' Check your internet connection.');
        });
    }, function(data) {
        return 1;
    });

    RadioService('Quickbooks_disconnectAuth', function(data, callback) {
        Balboa.api('/quickbooks/disconnectauth', {
            sid: data.sid
        }, function(data) {
            callback(null, data);
        }, function(data) {
            callback((data && data.message) || ' Check your internet connection.');
        });
    }, function(data) {
        return 1;
    });

    RadioService('Quickbooks_findCustomerByName', function(data, callback) {
        Balboa.api('/quickbooks/findcustomerbyname', {
            sid: data.sid,
            name: data.name
        }, function(data) {
            callback(null, data);
        }, function(data) {
            callback((data && data.message) || ' Check your internet connection.');
        });
    }, function(data) {
        return 1;
    });

    RadioService('Quickbooks_createInvoice', function(data, callback) {
        Balboa.api('/quickbooks/createinvoice', {
            sid: data.sid,
            name: data.name,
            customer_id: data.customer_id,
            services: data.services,
            products: data.products
        }, function(data) {
            callback(null, data);
        }, function(data) {
            callback((data && data.message) || ' Check your internet connection.');
        });
    }, function(data) {
        return 1;
    });

    RadioService('Quickbooks_addInvoiceToQueue', function(data, callback) {
        Balboa.api('/quickbooks/addinvoicetoqueue', {
            sid: data.sid,
            name: data.name,
            customer_id: data.customer_id,
            services: data.services,
            products: data.products
        }, function(data) {
            callback(null, data);
        }, function(data) {
            callback((data && data.message) || ' Check your internet connection.');
        });
    }, function(data) {
        return 1;
    });


};


// WEBPACK FOOTER //
// ./src/services/QuickBooks.js